import { z } from "zod";
export const channelPostAuthorTypeSchema = z.enum(["user", "agent", "service"]);
export const channelFeedReactionSchema = z.enum([
    "thumbs_up", "heart", "laugh", "celebrate", "eyes", "check",
]);
export const channelFeedReactionActorSchema = z.object({
    actorId: z.string().trim().min(1),
    actorType: channelPostAuthorTypeSchema,
}).strict();
export const channelFeedReactionSummarySchema = z.object({
    reaction: channelFeedReactionSchema,
    count: z.number().int().positive(),
    reactedByViewer: z.boolean(),
    actors: z.array(channelFeedReactionActorSchema).max(8),
}).strict();
export const channelFeedEngagementSchema = z.object({
    commentCount: z.number().int().nonnegative(),
    unreadCount: z.number().int().nonnegative(),
    participantIds: z.array(z.string().trim().min(1)).max(8),
    reactions: z.array(channelFeedReactionSummarySchema),
}).strict();
